module.exports = __webpack_public_path__ + "static/media/sanaa.b18790ce.png";